// The wire format is `string | null` (see NoteSyncModelDataResponseSchema), so
// unrecognized values collapse to null in
// getAttributionContextLabel rather than throwing.
export type AttributionContextKind =
  | "chat"
  | "mem_agent"
  | "voice_mode"
  | "email"
  | "clean_up"
  | "mcp"
  | "zapier"
  | "web_clip"
  | "unknown";

const LABELS: Record<AttributionContextKind, string> = {
  chat: "Chat",
  mem_agent: "Mem Agent",
  voice_mode: "Voice Mode",
  email: "Email",
  clean_up: "Clean Up",
  mcp: "MCP",
  zapier: "Zapier",
  web_clip: "Web Clip",
  unknown: "",
};

export const getAttributionContextLabel = (kind: string | null | undefined): string | null => {
  if (!kind) return null;
  const label = (LABELS as Record<string, string | undefined>)[kind];
  return label && label.length > 0 ? label : null;
};
